import callWebGate from './callWebGate';
import { appendCachebuster } from 'utilities';

export function getUserAbbaFlags(wgToken) {
  const url = `abba-service/v1/resolve?format=json`;

  return callWebGate(appendCachebuster(url), wgToken, undefined, 'prod')
    .then(r => {
      if (!r.ok) return Promise.reject(r.statusText);
      return r.json();
    });
}



// WEBPACK FOOTER //
// ./src/api/featureFlags.js